const WP_ENVIRONMENT = import.meta.env.VITE_ENV || 'local';

const LOGOS = {
    motiliWhite:
        'https://static.motili.com/images/logos/motili-all-white-logo-300x158.png',
};

const config = {
    local: {
        apiBaseUrl: 'http://localhost:3000/api',
        baseCDNURL: 'https://static.motili.com/',
        aws: {
            s3: {
                motiliFiles: {
                    bucketName: 'dev-motili-files',
                    identityPoolId:
                        'us-west-2:32b7f8c5-cea7-4a57-8fb5-2c71aff6a6e5',
                },
            },
        },
        logos: LOGOS,
    },
    dev: {
        apiBaseUrl: 'https://api2.motilidev.com/api',
        baseCDNURL: 'https://static.motili.com/',
        aws: {
            s3: {
                motiliFiles: {
                    bucketName: 'dev-motili-files',
                    identityPoolId:
                        'us-west-2:32b7f8c5-cea7-4a57-8fb5-2c71aff6a6e5',
                },
            },
        },
        logos: LOGOS,
    },
    dev2: {
        apiBaseUrl: 'https://api2.motilidev.com/api',
        baseCDNURL: 'https://static.motili.com/',
        aws: {
            s3: {
                motiliFiles: {
                    bucketName: 'dev-motili-files',
                    identityPoolId:
                        'us-west-2:32b7f8c5-cea7-4a57-8fb5-2c71aff6a6e5',
                    region: 'us-west-2',
                },
            },
        },
        logos: LOGOS,
    },
    qa: {
        apiBaseUrl: 'https://api.motilitest.com/api',
        baseCDNURL: 'https://static.motili.com/',
        aws: {
            s3: {
                motiliFiles: {
                    bucketName: 'qa-motili-files',
                    identityPoolId:
                        'us-west-2:4b17ee30-43d0-49a6-ae09-b399188a2ca0',
                },
            },
        },
        logos: LOGOS,
    },
    stage: {
        apiBaseUrl: 'https://api.motilistage.com/api',
        baseCDNURL: 'https://static.motili.com/',
        aws: {
            s3: {
                motiliFiles: {
                    bucketName: 'stage-363661057300-motili-files',
                    identityPoolId:
                        'us-west-2:7f59399c-2fad-4e59-b6fe-338f47226c61',
                },
            },
        },
        logos: LOGOS,
    },
    production: {
        apiBaseUrl: 'https://api.motili.com/api',
        baseCDNURL: 'https://static.motili.com/',
        aws: {
            s3: {
                motiliFiles: {
                    bucketName: 'prod-131227886246-motili-files',
                    identityPoolId:
                        'us-west-2:5355b015-2e66-4c1d-8c4b-b302851097d7',
                },
            },
        },
        logos: LOGOS,
    },
};

// @ts-ignore
export default config[WP_ENVIRONMENT];
